<template>
  <v-card>
    <v-toolbar color="transparent" flat>
      <!-- Toggle form -->
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            fab
            x-small
            outlined
            @click="toggleForm"
          >
            <v-icon>mdi-swap-horizontal</v-icon>
          </v-btn>
        </template>
        <span>{{ tooltipMsg }}</span>
      </v-tooltip>

      <!-- End toggle form -->

      <v-spacer></v-spacer>
      <v-toolbar-title class="sokoDeep--text text-uppercase">{{
        formType === "login" ? "Login" : "Sign up"
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        fab
        x-small
        outlined
        @click="closeAuthForm"
        v-if="$route.name !== 'Auth'"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <v-container>
        <LoginForm
          v-bind:rules="validationRules"
          v-if="formType === 'login'"
          @loginSuccess="emitEvent('loginSuccess')"
        />
        <SignupForm
          v-bind:rules="validationRules"
          v-if="formType === 'signup'"
          @signupIsSuccess="emitEvent('signupSuccess')"
          @loginFailure="emitEvent('loginFailure')"
        />
      </v-container>
    </v-card-text>

    <v-card-actions class="text-uppercase text-center d-block">
      <span class="grey--text"
        >or {{ formType === "login" ? "login" : "sign up" }} using</span
      >
      <br />
      <div class="d-none d-sm-flex justify-center mt-6">
        <form :action="`${oauth}/twitter`" method="GET">
          <v-btn type="submit" class="ma-2" color="#00acee" dark depressed>
            <v-icon left>mdi-twitter</v-icon>twitter
          </v-btn>
        </form>
        <form :action="`${oauth}/google`" method="GET">
          <v-btn type="submit" class="ma-2" color="#db3236" dark depressed>
            <v-icon left>mdi-google</v-icon>google
          </v-btn>
        </form>
        <form :action="`${oauth}/facebook`" method="GET">
          <v-btn type="submit" class="ma-2" color="#3b5998" dark depressed>
            <v-icon left>mdi-facebook</v-icon>facebook
          </v-btn>
        </form>
      </div>
      <div class="d-flex d-sm-none justify-center mt-6">
        <form :action="`${oauth}/twitter`" method="GET">
          <v-btn
            type="submit"
            class="ma-2"
            color="#00acee"
            dark
            depressed
            fab
            small
          >
            <v-icon>mdi-twitter</v-icon>
          </v-btn>
        </form>
        <form :action="`${oauth}/google`" method="GET">
          <v-btn
            type="submit"
            class="ma-2"
            color="#db3236"
            dark
            depressed
            fab
            small
          >
            <v-icon>mdi-google</v-icon>
          </v-btn>
        </form>
        <form :action="`${oauth}/facebook`" method="GET">
          <v-btn
            type="submit"
            class="ma-2"
            color="#3b5998"
            dark
            depressed
            fab
            outlined
            small
          >
            <v-icon style="font-size: 2.4rem">mdi-facebook</v-icon>
          </v-btn>
        </form>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import LoginForm from "./Login.vue";
import SignupForm from "./Signup.vue";
import validationRules from "@/externals/logic/ValidationRules.js";

export default {
  name: "AuthForm",
  components: {
    LoginForm,
    SignupForm,
  },
  props: {
    authType: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    formTypeVal: "", // login or signup - default param form formType
    oauth: "https://api-endpoints-sokodelivery.herokuapp.com/user/oauth", // oauth base url

    validationRules,
  }),
  methods: {
    closeAuthForm() {
      // emit event to close the authentication form dialog
      this.formTypeVal = ""; // clear form type value
      this.$emit("closeAuthFormDialog");
    },
    emitEvent(type) {
      let color = "success";
      let msg = "Success!";

      if (type === "loginSuccess") msg = "Login successful";
      else if (type === "signupSuccess")
        msg =
          "Your SokoDelivery Account has been successfully created. Please wait while we log you in.";
      else if (type === "loginFailure") {
        msg =
          "An error occured while logging you in. Please try logging in again.";
        color = "error";
      }

      // emit custom events
      this.$emit("showSnackbar", { msg, color });
      this.closeAuthForm();
    },
    toggleForm() {
      if (this.formType === "login") this.formType = "signup";
      else if (this.formType === "signup") this.formType = "login";
    },
  },
  computed: {
    formType: {
      // check if authType prop was passed set the form type appropriately,
      // else the computed formType, and formTypeValue will cause the form
      // to display the default form which is login
      get() {
        return this.authType && this.formTypeVal === ""
          ? this.authType
          : this.formTypeVal
          ? this.formTypeVal
          : "login";
      },
      set(val) {
        this.formTypeVal = val;
      },
    },
    tooltipMsg() {
      return this.formType === "login" ? "Signup instead!" : "Login instead!";
    },
  },
};
</script>

<style scoped>
span.headline {
  font-family: inherit;
}
</style>
